import faker from 'faker';
import PageContainer from './PageContainer';
import session from '../models/Session';

export default class TemplateSelectPageContainer extends PageContainer {
  state = {
    selectedTemplate: null,
  }

  mockTemplates = [...Array(9).keys()].map(() => ({
    _id: faker.random.uuid(),
    name: faker.company.bs(),
    blurb: faker.company.catchPhrase(),
  }))

  selectTemplate(template) {
    session.selectTemplate(template);
    this.setState(state => {
      return {
        selectedTemplate: template
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/containers/TemplatesContainer.js